import HeroContent from "@/components/landing/hero/HeroContent";
import HeroMedia from "@/components/landing/hero/HeroMedia";

const HeroSection = () => (
  <section className="hero" id="hero" data-testid="hero-section">
    <HeroContent />
    <HeroMedia />
  </section>
);

export default HeroSection;